const keyCodes = {
  esc: 27,
}

export default keyCodes
export { keyCodes }

export const dateToYear = (date) => date.split('.')[2]

export const formatCurrency = (amount) =>
  amount
    .toFixed(2)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")
